<template>
  <div class="wrap">
    <ul class="">
      <li><a href="gylwhole.html">查看全部</a></li>
      <li class="" @click="source(i.id)" v-for="(i,index) in list" :key="index" :class="{active:iSsource == i.id}">{{i.name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'classification',
  props: {
    iSsource: Number
  },
  data () {
    return {
      list: [{
        name: '平台自营',
        id: 1
      }, {
        name: '京东自营',
        id: 2
      }, {
        name: '苏宁',
        id: 3
      }, {
        name: '网易严选',
        id: 4
      }],
      type: this.url('type')
    }
  },
  methods: {
    url (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2]); return null
    },
    source (id) {
      console.log(id)
      if(id<=2) {
        this.$emit('isClassifyAction', id)
      } else {
        this.$emit('kong',id)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.wrap
  height px(90)
  background #F2F2F2
  ul
    display flex
  li
    height px(90)
    line-height px(90)
    font-size px(28)
    cursor pointer
    margin-left px(20)
    color #333
    position relative
    a
      color #333
  .active
    color #C4A868
  .active:before
    content ''
    position absolute
    bottom px(6)
    width px(74)
    height px(6)
    background #C4A868
    left 50%
    transform translate(-50%,0)
    border-radius px(3)
</style>



// WEBPACK FOOTER //
// src/pages/gyl/components/classification.vue